export type NotificationLevel = "warning" | "info" | "success" | "error";

export type NotificationType = {
  id?: string;
  isOpen?: boolean;
  level?: NotificationLevel;
  title?: string;
  body?: string;
  onCancelLabel?: string;
  onConfirmLabel?: string;
  onConfirm?: Function;
  onCancel?: Function;
  onClose?: Function;
  setClose: () => void;
  doAction: (action: Function | undefined) => void;
};

export const KEYS = {
  ENTER: 'Enter',
  NUM_ENTER: 'NumpadEnter',
  ESC: 'Escape',
};
